import TeacherDetailsModal from "./TeacherDetailsModal";

export default TeacherDetailsModal;
